import React, { useState, useEffect } from "react";
import { observer, useObserver } from "mobx-react";
import { v4 as uuid } from "uuid";
import { Tooltip } from "antd";
import { NodeViewWrapper } from "@tiptap/react";
import cn from "classnames";

import commentStore from "@app/state/store/report-document/comment";

import "./style.scss";

export default observer(({ editor, node, extension, getPos }) => {
    const store = extension.storage.store;
    const [nodeId] = useState(() => uuid());
    const { comment } = node.attrs;
    const isHighlighted = comment && comment.includes(commentStore.focusedComment);
    const status =
        commentStore.focusedComment &&
        commentStore.comments.find((c) => c._id === commentStore.focusedComment)?.status;
    // re-render the component upon store change
    useObserver(() => store.entries);

    /**
     * Remove the entry
     */
    const remove = ({ node }) => {
        if (node.attrs.key === key) {
            const from = getPos();
            const to = from + node.nodeSize;

            editor.chain().deleteRange({ from, to }).focus().run();
        }
    };

    useEffect(() => {
        if (!editor) {
            return;
        }

        editor.on("removeAbbreviation", remove);

        return () => editor.off("removeAbbreviation", remove);
    }, [editor]);

    useEffect(() => {
        return () => {
            if (store && key) {
                store.unuse(key, nodeId);
            }
        };
    }, []);

    // do not render the node in case if missing id
    const key = node.attrs.key;
    if (!key) {
        return null;
    }

    // do not render the node if we don't have a abbreviation entry
    const entry = store.use(key, nodeId);
    const invalid = !entry;

    const Entry = observer(({ entry }) => {
        return (
            <Tooltip title={entry.text} placement="top">
                {entry.name}
            </Tooltip>
        );
    });

    if (invalid) {
        return (
            <NodeViewWrapper
                className={cn({
                    "abbreviation-entry": true,
                    invalid: true,
                    pending: isHighlighted && status === "pending",
                    resolved: isHighlighted && status === "resolved",
                })}
            >
                {key}
            </NodeViewWrapper>
        );
    }

    return (
        <NodeViewWrapper
            className={cn({
                "abbreviation-entry": true,
                pending: isHighlighted && status === "pending",
                resolved: isHighlighted && status === "resolved",
            })}
        >
            <Entry entry={entry} />
        </NodeViewWrapper>
    );
});
